import actions from "./actions";

const updateOrder = actions.updateOrder;
const placeOrder = actions.placeOrder;

export default {
  updateOrder,
  placeOrder
};
